import React from "react";
import { useTranslation } from "react-i18next";
import CustomModal from "../../modals/CustomModal";

const DemoErrorModal = ({
  visible,
  setVisible,
  errorMsg,
  unsetRequestId,
}) => {
  const { i18n, t } = useTranslation();

  return (
    <CustomModal
      visible={visible}
      setVisible={setVisible}
      title="Aanvraag mislukt"
      btnText={"Annuleer"}
      btnColor={"#439BD9"}
      btnOnClick={() => {
        unsetRequestId();
        setVisible(false);
      }}
      width="500px"
    >
      Aanvraag mislukt: <span>{errorMsg}</span>
    </CustomModal>
  );
};

export default DemoErrorModal;
